import React from 'react';
import {Auth} from 'aws-amplify';
import {SignOut} from "aws-amplify-react";
import APP_ENV from "../Environment";
import WgsConsentComponent from "../Components/WgsConsentComponent";
import {oidcUserlogout} from "../Logics/oauth";

export default class WgsConsent extends SignOut {
    constructor() {
        super();
        this._validAuthStates = ['wgsConsent'];
        this.state = {
            msg: "",
            execute_action: false,
            oidc_connect_exist: false,
        };
    }
    signOut() {
        let oidc_conenct = false;
        if (!this.state.execute_action) {
            Auth.currentAuthenticatedUser()
                .then(user => {
                    if (user.attributes.identities) {
                        oidc_conenct = true;
                    }
                    this.setState({
                        msg: "",
                        execute_action: true,
                        oidc_connect_exist: oidc_conenct,
                    })
                    this.sign_out_process(oidc_conenct);
                }).catch(err => {
                    oidc_conenct = true;
                    this.setState({
                        execute_action: true
                    });
                    this.sign_out_process(oidc_conenct);
            });

        }

    }

    async doConsent() {
        window.location.href = APP_ENV.ECC_WGS_REG;
    }

    sign_out_process(oidc_conenct) {
        Auth.signOut()
            .then(() => {
                this.setState({
                    // msg: "コンニチハWGSコンセント",
                    oidc_connect_exist: oidc_conenct,
                })
            })
            .catch(() => {
                this.setState({
                    msg: "ログアウトに失敗しました。",
                    execute_action: true,
                    oidc_connect_exist: oidc_conenct,
                })
            });
    }

    render(theme) {
        if (this.props.authState !== "wgsConsent") { return null; }
        const msg = this.state.msg;
        return (
            <WgsConsentComponent theme={theme} msg={msg}
                              changeStateFunc={() => {
                                  this.move_sign_up();
                              }}
                              signOut={() => {
                                  this.signOut();
                              }}
                              doConsent={this.doConsent}
            />
        )
    }
    move_sign_up() {
        window.history.replaceState('', '', '/');
        this.changeState('signUp');
    }

    move_sign_in() {
        if (this.state.oidc_connect_exist) {
            oidcUserlogout().then(() => this.changeState('signIn')).catch(() => this.changeState('signIn'))
            window.history.replaceState('','','/');
        } else {
            window.history.replaceState('', '', '/');
            this.changeState('signIn');

        }
    }
}